import { useContext } from 'react';
import { SnackbarContext } from './SnackbarContext';

/**
 * Custom hook to access the snackbar context.
 *
 * @example
 * ```tsx
 * const { showSnackbar, hideSnackbar } = useSnackbar();
 *
 * // Show a success message
 * showSnackbar('Operation successful!', 'success');
 *
 * // Show an error with auto-hide
 * showSnackbar('Something went wrong', 'error', { hideDelay: 5000 });
 *
 * // Show with action button
 * showSnackbar('File deleted', 'success', {
 *   action: {
 *     name: 'Undo',
 *     callback: () => console.log('Undo clicked')
 *   },
 *   hideDelay: 10000
 * });
 * ```
 */
export const useSnackbar = () => {
  const context = useContext(SnackbarContext);

  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }

  return context;
};
